import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function CallToAction() {
    return (
        <section data-testid="cta-section" className="py-24 md:py-40 bg-[var(--navy)] hairline-b">
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-24">
                <div className="grid md:grid-cols-12 gap-10">
                    <div className="md:col-span-8">
                        <div className="label-mono mb-6">— THE INVITATION</div>
                        <motion.h2
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
                            className="serif-display text-4xl md:text-6xl lg:text-8xl leading-[0.95]"
                        >
                            If not this generation, <br className="hidden md:block" />
                            <span className="serif-italic text-[var(--gold)]">then which?</span>
                        </motion.h2>
                        <p className="mt-8 text-lg md:text-xl text-[var(--ivory)]/80 max-w-2xl">
                            Applications for the 2026 cohort are open. Whether you're a student, professional, educator, entrepreneur or public leader — there is a place for you inside the movement.
                        </p>
                        <div className="mt-10 flex flex-wrap gap-3">
                            <Link to="/apply" className="btn-gold" data-testid="cta-apply-btn">
                                Apply for 2026 <ArrowUpRight className="w-4 h-4" />
                            </Link>
                            <Link to="/contact" className="btn-ghost" data-testid="cta-contact-btn">
                                Speak with the team
                            </Link>
                        </div>
                    </div>

                    <div className="md:col-span-4 flex md:justify-end items-start">
                        <div className="border border-[rgba(255,255,240,0.2)] p-8 md:p-10 max-w-sm">
                            <div className="label-mono text-[var(--gold)]">— PARTNER WITH US</div>
                            <h3 className="serif-display text-2xl md:text-3xl mt-4 leading-tight">
                                Universities, ministries, foundations, corporates.
                            </h3>
                            <p className="mt-4 text-sm text-[var(--ivory)]/70">
                                Sponsor a delegate, host a chapter, co-create a program. Reach global cohorts through Z Ed.
                            </p>
                            <Link to="/contact" className="btn-ghost mt-6" data-testid="cta-partner-btn">
                                Start a conversation
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
